import React from 'react';
import '../styles/policy.css';
import '../styles/services.css'

const Checkout = ({ onClose, success }) => {
    return (
        <div className="modal">
            <div className="modal-content policy-section">
                <span className="close" onClick={onClose}>&times;</span>
                {success ? (
                    <div id="form-success" className="form-success">
                        <div className="success-icon">
                            <svg viewBox="0 0 24 24" width="48" height="48">
                                <path fill="currentColor"
                                      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                            </svg>
                        </div>
                        <h2>🎉 Subscription Confirmed!</h2>
                        <h3>Welcome to Intellommerce AI</h3>
                        <p>Your subscription is now active, and your digital journey has officially begun.</p>
                        <p>We're excited to support you with intelligent automation and future-ready solutions.
                            Our team is already setting up your account, and you'll receive a confirmation email with your
                            subscription details shortly.</p>
                        <h3>Next Steps</h3>
                        <ul>
                            <li>Access your <button
                                className="secondary-button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    window.location.href = 'https://www.intellommerce.ai';
                                }}>Customer Portal</button> to manage your subscription.
                            </li>
                            <li></li>
                            <li>Check out our <button
                                className="secondary-button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onClose('features')
                                }}>Process</button>
                            </li>
                        </ul>
                        <p>Thank you for choosing <strong>Intellommerce AI</strong> — where innovation, automation, and
                            creativity converge. We're thrilled to have you on board.</p>
                    </div>
                ) : (
                    <div id="form-failure" className="form-success"> {/* Changed class name */}
                        <div className="success-icon"> {/* Changed class name */}
                            <svg viewBox="0 0 24 24" width="48" height="48">
                                <path fill="currentColor"
                                      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"/>
                            </svg>
                        </div>
                        <h2>🚪 Checkout Cancelled</h2>
                        <h3>You've chosen not to complete your subscription — and that's okay!</h3>
                        <p>No charges have been made, and your account remains unchanged.</p>
                        <h3>Ready When You Are</h3>
                        <ul>
                            <li>You can restart your subscription at any time by returning to the <button
                                className="secondary-button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onClose('pricing')
                                }}>Pricing Page</button>
                            </li>
                           <li></li>
                            <li>Explore our <button className="secondary-button"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        onClose('services')
                                                    }}>Services</button> to see what else Intellommerce AI can do
                                for you.
                            </li>
                            <li>If you have questions, our support team is happy to help: <a
                                href="mailto:support@yourcompany.com">support@intellommerce.ai</a>.
                            </li>
                        </ul>
                        <p>We appreciate your interest in <strong>Intellommerce AI</strong>.
                            Whenever you're ready to continue your digital journey, we'll be here to help you every step
                            of the way.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Checkout;